import { copy as sharedUiCopy } from '@shared/copy';
import { Skeleton } from '@shared/ui/Skeleton';

/**
 * The pending state of `/comments` — the held-comment queue.
 *
 * This queue is a run of CARDS rather than a table, because each held comment
 * carries its body, its author, its subject and two decisions; the placeholder
 * therefore draws cards at the same shape, each with the two action blocks on its
 * own row. A table skeleton here would reflow into cards on arrival.
 *
 * Three cards: the queue's depth is exactly what the read is about to answer, and
 * three is what states «a queue» without asserting a length — the truncation line
 * above the loaded list is what states the real count.
 */
export function CommentsSkeleton() {
  return (
    <>
      <p role="status" className="sr-only">
        {sharedUiCopy.state.loading}
      </p>

      <div className="grid gap-4">
        {Array.from({ length: 3 }, (_, index) => (
          <div key={index} className="grid gap-3 rounded-md border border-border bg-surface p-4">
            <Skeleton className="h-4 w-[9rem]" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />

            <div className="flex flex-wrap gap-3">
              <Skeleton className="h-[2.75rem] w-[7rem] rounded-sm" />
              <Skeleton className="h-[2.75rem] w-[7rem] rounded-sm" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
